import { put, select, takeEvery } from 'redux-saga/effects';

import { notify } from './actions';
import { getMessages } from './selectors';

function* putNotification({ payload: { response = {} } }) {
  const messages = yield select(getMessages);
  const { status: type = 0, data: content = '' } = response;
  const lastMessage = messages.length > 0 ? messages[messages.length - 1] : undefined;
  if (!lastMessage || Date.now() - lastMessage.key > 5000 || type !== lastMessage.type) {
    yield put(notify(type, content));
  }
}

function rejectedActionMatcher({ type, payload }) {
  if (type.indexOf('REJECTED') > -1 && (type.indexOf('LOGIN') === -1 || type.indexOf('REGISTER') === -1)) {
    const { response = {} } = payload || {};
    return !response.data || response.data.code !== 404;
  }
  return false;
}

function* watchRejectedActions() {
  yield takeEvery(rejectedActionMatcher, putNotification);
}

export default [watchRejectedActions];
